import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cartItems: [],
  activity: 0,
};

const lottoSlice = createSlice({
  name: 'lotto',
  initialState,
  reducers: {
    setCartItems: (state, action) => {
      state.cartItems = action.payload;
    },
    addToCart: (state, action) => {
      state.cartItems.push(action.payload);
      state.activity += 1;
    },
    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (item) => item.id !== action.payload
      );
    },
    updateCartItem: (state, action) => {
      const { id, updates } = action.payload;
      const index = state.cartItems.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.cartItems[index] = { ...state.cartItems[index], ...updates };
      }
    },
    clearCart: (state) => {
      state.cartItems = [];
    },
    resetActivity: (state) => {
      state.activity = 0;
    },
  },
});

export const {
  setCartItems,
  addToCart,
  removeFromCart,
  updateCartItem,
  clearCart,
  resetActivity,
} = lottoSlice.actions;

export default lottoSlice.reducer;
